import { useMemo } from 'react';

import { useWorkloadsOptimizationSummaryQuery } from '@cast/features-cluster-shared';
import { useCluster } from '@cast/shared-cluster-context-data-access';

import { AutoscalerImpactData, normalizeAutoscalerImpact } from '../_utils';

export const useAutoscalerImpactData = (): {
  data: AutoscalerImpactData | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
  refetch: () => void;
} => {
  const { cluster } = useCluster();
  const { data, isLoading, isFetching, error, refetch } =
    useWorkloadsOptimizationSummaryQuery({
      clusterId: cluster.id,
      enabled: !!cluster.id,
    });

  const normalizedData = useMemo(
    () => (data ? normalizeAutoscalerImpact(data) : undefined),
    [data]
  );

  return { data: normalizedData, isLoading, isFetching, error, refetch };
};
